/** Warren ruling 1 (17 October 2026): the Legacy Revenue Share of the twelve v1 host locations is written only by the host account
 * link script. The Api's GET returns script_managed from the same predicate that makes its POST answer 409 LEGACY_SHARE_SCRIPT_MANAGED,
 * so the card locks on that flag alone and never second-guesses it from the history. */
export const LEGACY_SHARE_SCRIPT_MANAGED_COPY = 'Set by the host account link script from the grandfather contract, so it cannot be changed here.';
export function legacyShareFormLocked(data: { script_managed?: unknown } | undefined): boolean {
  return data?.script_managed === true;
}
